export default "__VITE_ASSET__C$RXjx7S__"